exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "main {\n  height: 100%;\n}\na.link:link,\na.link:active,\na.link:visited {\n  color: #e6150e;\n  text-decoration: underline;\n}\na.link:hover {\n  text-decoration: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/App.less
// module id = 994
// module chunks = 0